
import {Vue, Component, Prop} from 'vue-property-decorator';

type BootstrapDropdownButtonOption = {
  index: number;
  name: string;
  default?: boolean;
};

@Component({})
export default class vDropdownButton extends Vue {
  @Prop() title!: string;
  @Prop() options!: BootstrapDropdownButtonOption[];

  selectedOption: BootstrapDropdownButtonOption = null;

  updateSelectedOption(index: number) {
    this.selectedOption = this.options.find((option) => option.index === index);
  }

  created() {
    this.selectedOption = this.options.find((option) => option.default) || { index: -1, name: this.title };
  }
}
